module.exports = __webpack_public_path__ + "static/showreel-ad673d4f53ab9d473a9b3cccb373dd9c.mp4";